import { render, staticRenderFns } from "./ProfoSearch.vue?vue&type=template&id=2697a563&"
import script from "./ProfoSearch.vue?vue&type=script&lang=js&"
export * from "./ProfoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2697a563')) {
      api.createRecord('2697a563', component.options)
    } else {
      api.reload('2697a563', component.options)
    }
    module.hot.accept("./ProfoSearch.vue?vue&type=template&id=2697a563&", function () {
      api.rerender('2697a563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ProfoSearch.vue"
export default component.exports